import { useState } from "react";
import { Eye, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DataTable, PageHeader, FilterSelect, StatusBadge, useList } from "@/components/shared";
import { Viewer } from "@/components/DocumentsPanel";
import { downloadFile, fmtDateTime, label } from "@/lib/api";

export default function DocumentsPage() {
  const [q, setQ] = useState("");
  const [f, setF] = useState({ category: "", entity_type: "", from: "", to: "" });
  const [rows] = useList("/documents", { q, ...f });
  const [view, setView] = useState(null);
  return (
    <div>
      <PageHeader title="Documenti" subtitle="Archivio privato per società, cliente, veicolo, prenotazione e noleggio. Nessun link pubblico: download solo per utenti autorizzati." />
      <div className="flex flex-col md:flex-row flex-wrap gap-2 mb-4">
        <Input placeholder="Cerca per targa, marca, modello, nome file, cliente…" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 flex-1 min-w-[220px]" data-testid="documents-search" />
        <FilterSelect value={f.category} onChange={(v) => setF({ ...f, category: v })} placeholder="Categoria" testid="filter-doc-category"
          options={["libretto", "cliente_documento", "contratto", "contratto_firmato", "manutenzione", "generico"]} />
        <FilterSelect value={f.entity_type} onChange={(v) => setF({ ...f, entity_type: v })} placeholder="Collegato a" testid="filter-doc-entity"
          options={[["customer", "Cliente"], ["vehicle", "Veicolo"], ["booking", "Prenotazione"], ["rental", "Noleggio"]]} />
        <Input type="date" value={f.from} onChange={(e) => setF({ ...f, from: e.target.value })} className="h-10 w-full md:w-40" data-testid="filter-doc-from" />
        <Input type="date" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} className="h-10 w-full md:w-40" data-testid="filter-doc-to" />
      </div>
      <DataTable rows={rows} testid="documents-table" columns={[
        { key: "filename", label: "File", render: (r) => <span className="font-medium">{r.filename}</span> },
        { key: "category", label: "Categoria", render: (r) => label(r.category) },
        { key: "entity_label", label: "Riferimento", render: (r) => [r.entity_label, r.brand, r.model].filter(Boolean).join(" · ") || "—" },
        { key: "side", label: "Lato" }, { key: "uploaded_at", label: "Caricato", render: (r) => fmtDateTime(r.uploaded_at) }, { key: "uploaded_by", label: "Da" },
        { key: "is_stamped", label: "Tipo", render: (r) => (r.is_stamped ? <StatusBadge text="Copia timbrata" tone="amber" /> : <StatusBadge text="Originale" tone="green" />) }]}
        actions={(r) => <div className="flex gap-1 justify-end">
          <Button size="icon" variant="ghost" onClick={() => setView(r)} data-testid={`view-doc-${r.id}`}><Eye size={15} /></Button>
          <Button size="icon" variant="ghost" onClick={() => downloadFile(`/documents/${r.id}/download`, r.filename)} data-testid={`download-doc-${r.id}`}><Download size={15} /></Button></div>} />
      <Viewer doc={view} onClose={() => setView(null)} />
    </div>
  );
}
